import { Link } from "react-router-dom";
import { Instagram, Youtube, Twitter } from "lucide-react";
import { IMAGES } from "@/lib/content";
import { NewsletterForm } from "@/components/NewsletterForm";

const ECOSYSTEM = [
  { label: "The Shift (Book)", to: "/book" },
  { label: "The System", to: "/system" },
  { label: "Builders Circle", to: "/builders-circle" },
  { label: "Read Chapter One", to: "/preview" },
  { label: "Articles", to: "/articles" },
];

const COMPANY = [
  { label: "Our Mission", to: "/philosophy" },
  { label: "About Don", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

const FUTURE = ["Builder Podcast", "Builder Weekly", "Builder Summit", "Builder Academy"];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 noise">
      <div className="relative z-10 max-w-[1240px] mx-auto px-6 lg:px-10 py-24">
        {/* Newsletter — Builder Weekly */}
        <div className="border border-white/12 p-10 lg:p-14 mb-20 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div className="max-w-md">
            <h3 className="font-display text-3xl text-white">Builder Weekly</h3>
            <p className="font-body text-white/55 mt-3">
              One idea a week to help you build a life of purpose. No noise. Unsubscribe anytime.
            </p>
          </div>
          <NewsletterForm
            sourcePage="footer-builder-weekly"
            tags={["Newsletter"]}
            buttonText="Subscribe"
            testId="footer-newsletter"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-14">
          <div className="md:col-span-4">
            <img src={IMAGES.logo} alt="Employee 2 Employer" className="h-12 w-auto" />
            <p className="font-display text-2xl text-white mt-8 leading-snug max-w-xs">
              Stop surviving.<br />
              <span className="text-[#D4AF37]">Start building.</span>
            </p>
            <p className="font-body text-sm text-white/50 mt-6 max-w-xs leading-relaxed">
              A movement for people who know they were created for more — helping you build a
              life of purpose, integrity, and lasting impact.
            </p>
            <div className="flex gap-3 mt-8">
              {[
                { Icon: Instagram, label: "Instagram" },
                { Icon: Youtube, label: "YouTube" },
                { Icon: Twitter, label: "X" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-11 h-11 border border-white/20 flex items-center justify-center text-white/60 hover:text-black hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors duration-300"
                >
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-6">
              The Ecosystem
            </h4>
            <ul className="space-y-3">
              {ECOSYSTEM.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-body text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-6">
              Company
            </h4>
            <ul className="space-y-3">
              {COMPANY.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-body text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-6">
              Coming Soon
            </h4>
            <ul className="space-y-3">
              {FUTURE.map((f) => (
                <li key={f} className="font-body text-sm text-white/40">
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40 tracking-wide">
            © {new Date().getFullYear()} Employee 2 Employer LLC · Employee2Employer.com
          </p>
          <p className="font-body text-xs text-white/50 tracking-[0.14em]">
            Build with purpose. Serve with excellence. Leave a legacy.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
